module.exports = require("@material-ui/core/SnackbarContent");